export default __webpack_public_path__ + "static/media/018-roller coaster.b9aef394.svg";